module.exports = __webpack_public_path__ + "static/img/brand2.edf4217b.png";